'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadt';
var iconName = 'circle-notch';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'f1ce';
var svgPathData = ['', 'M224 9.9c.7 4.4-2.3 8.5-6.6 9.2-114.2 18.5-201.4 117.5-201.4 236.9 0 132.5 107.5 240 240 240S496 388.5 496 256c0-119.4-87.2-218.4-201.4-236.9-4.4-.7-7.3-4.8-6.6-9.2s4.8-7.3 9.2-6.6C419 23 512 128.6 512 256 512 397.4 397.4 512 256 512S0 397.4 0 256c0-127.4 93-233 214.8-252.7 4.4-.7 8.5 2.3 9.2 6.6z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faCircleNotch = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;